import classNames from 'classnames';
import styles from './activity.module.scss';

type TActivityProps = {
  activity: ILabActivity;
  selectedLab: Array<ILabActivity>;
  setSelectedLab: React.Dispatch<React.SetStateAction<ILabActivity[]>>;
};

const Activity = ({activity, selectedLab, setSelectedLab}: TActivityProps) => {
  const selectLab = () => {
    if (selectedLab.some(x => x.id === activity.id)) {
      setSelectedLab(prev => prev.filter(x => x.id !== activity.id));
      return;
    }
    setSelectedLab(prev => [...prev, activity]);
  };
  const isActive = selectedLab.some(x => x.id === activity.id);
  return (
    <>
      <div className={classNames('col-6 mb-3 h-100')}>
        <div
          className={classNames(
            'd-flex flex-column align-items-center text-center justify-content-center pb-3',
            styles['menu-item'],
            isActive && styles['menu-item__active'],
          )}
          onClick={selectLab}
        >
          <img src={activity.icon} alt={activity.title} />
          {isActive && <i className="icon-icon-select color-secondary"></i>}
          <span className="color-gray-1">{activity.title}</span>
        </div>
      </div>
    </>
  );
};

export default Activity;
